<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/merchanteclinechart/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="生日范围">
        <div style="display: flex">
          <div style="margin-right: 5px">
            <el-select
              v-model="formModel.monthstart"
              clearable
              placeholder="请选择月份"
              style="width: 150px"
            >
              <el-option
                v-for="item in month"
                :key="item.value"
                :label="item.value + '月'"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 150px"
              v-model="formModel.daystart"
              clearable
              placeholder="请选择日期"
            >
              <el-option
                v-for="item in day"
                :key="item.value"
                :label="item.value + '日'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          ~
          <div style="margin-left: 5px">
            <el-select
              v-model="formModel.monthend"
              clearable
              placeholder="请选择月份"
              style="width: 150px"
            >
              <el-option
                v-for="item in month"
                :key="item.value"
                :label="item.value + '月'"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 150px"
              v-model="formModel.dayend"
              clearable
              placeholder="请选择日期"
            >
              <el-option
                v-for="item in day"
                :key="item.value"
                :label="item.value + '日'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
    </common-top-form>
    <div id="test_app">
      <div id="main" style="width: 100%; height: 520px; background: #fff"></div>
    </div>
  </div>
</template>
 
<script>
import echarts from "echarts";
import MonthNum from "service/constant/MonthNum";
import DayNum from "service/constant/DayNum";
import CommonTopForm from "components/common/CommonTopForm";
import StatisticsService from "service/StatisticsService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchanteclinechart",
  components: {
    CommonTopForm,
  },
  data() {
    return {
      formModel: {
        monthstart: "",
        daystart: "",
        monthend: "",
        dayend: "",
      },
      submitService: StatisticsService.merchanteclinechartList,
      charts: "",
      opinionData: [], //数据
      month: MonthNum,
      day: DayNum,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.$nextTick(function () {
      this.drawLine("main");
    });
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        startDate: this.formModel.monthstart + this.formModel.daystart,
        endDate: this.formModel.monthend + this.formModel.dayend,
      };
      console.log(params);
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {};
      // this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        const xAxisData = result.map((item) => item.name);
        const yAxisData = result.map((item) => item.value);
        // 将xAxisData和yAxisData作为折线图的X轴和Y轴数据
        this.charts.setOption({
          xAxis: {
            data: xAxisData,
          },
          series: [
            {
              data: yAxisData,
            },
          ],
        });
      });
    },
    drawLine(id) {
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          align: "right", //文字在前图标在后
          left: "3%",
          top: "15%",
          data: ["近一周"],
        },
        grid: {
          x: 40,
          y: 60,
          x2: 50,
          y2: 20,
          containLabel: true, // 自动计算合适的边距
        },
        // toolbox: {//保存为图片
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          boundaryGap: true,
          name: "生日",
          axisTick: {
            alignWithLabel: true, //保证刻度线和标签对齐
          },
          data: [], //x坐标的名称
          // axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
          boundaryGap: true,
          name: "数量(人)", // x轴标注名称
          splitNumber: 10, //纵坐标数
          interval: 1, //强制设置坐标轴分割间隔
          splitLine: {
            show: true, // 显示纵向网格线
          },
          axisLabel: {
            formatter: function (value) {
              if (value % 1 === 0) {
                return value;
              } else {
                return "";
              }
            },
          },
        },
        // dataZoom: [ //X轴拖拽
        //   {
        //     type: "slider",
        //     start: 0,
        //     end: 30,
        //     // 最大的放大是图形的2%
        //     maxSpan: 30,
        //   },
        //   {
        //     start: 0,
        //     end: 30,
        //   },
        // ],

        series: [
          {
            name: "数量(人)",
            type: "line", //折线图line;柱形图bar;饼图pie
            data: [],
            symbol: "circle", //修改交叉点样式
            symbolSize: 15, //修改交叉点大小
            label: {
              show: false,
              position: "right",
              textStyle: {
                fontSize: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "#f90",
              },
            },
            lineStyle: {
              color: "#f90",
            },
            itemStyle: {
              color: "rgb(255,96,64)", //改变折线点的颜色
              lineStyle: {
                color: "rgb(255,96,64)", //改变折线颜色
              },
            },
            data: this.opinionData,
          },
        ],
      });
    },
  },
};
</script>
 
<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/page/Statistics/MerchantEcLineChart.vue